function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Capability-only bridge to RedSquare.
 *
 * Bugs deliberately does not import RedSquare classes. The `redsquare-api`
 * response documented in docs/todo.md is the contract required for content and
 * thread integration. Keeping this boundary explicit lets RedSquare remain
 * the sole owner of tweets, composers, images, replies and notifications.
 */
var RedSquareBridge = /*#__PURE__*/function () {
  function RedSquareBridge(app, mod) {
    _classCallCheck(this, RedSquareBridge);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(RedSquareBridge, [{
    key: "api",
    value: function api() {
      var _this$app$modules$ret, _this$app$modules;
      return ((_this$app$modules$ret = (_this$app$modules = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'redsquare-api', {
        consumer: this.mod.name
      })) || null;
    }
  }, {
    key: "available",
    value: function available(method) {
      var _this$api;
      return typeof ((_this$api = this.api()) === null || _this$api === void 0 ? void 0 : _this$api[method]) === 'function';
    }
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(method) {
        var api,
          _len,
          args,
          _key,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              api = this.api();
              if (!(!api || typeof api[method] !== 'function')) {
                _context.n = 1;
                break;
              }
              throw new Error("RedSquare does not expose ".concat(method, " through respondTo(\"redsquare-api\")"));
            case 1:
              for (_len = _args.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = _args[_key];
              }
              return _context.a(2, api[method].apply(api, args));
          }
        }, _callee, this);
      }));
      function call(_x) {
        return _call.apply(this, arguments);
      }
      return call;
    }()
  }, {
    key: "registerPeer",
    value: function registerPeer(peer) {
      return this.call('registerPeer', peer);
    }
  }, {
    key: "composeRoot",
    value: function () {
      var _composeRoot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, this.call('composeRoot', options));
          }
        }, _callee2, this);
      }));
      function composeRoot(_x2) {
        return _composeRoot.apply(this, arguments);
      }
      return composeRoot;
    }()
  }, {
    key: "composeReply",
    value: function () {
      var _composeReply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              return _context3.a(2, this.call('composeReply', options));
          }
        }, _callee3, this);
      }));
      function composeReply(_x3) {
        return _composeReply.apply(this, arguments);
      }
      return composeReply;
    }()
  }, {
    key: "renderThread",
    value: function () {
      var _renderThread = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(container, options) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              return _context4.a(2, this.call('renderThread', container, options));
          }
        }, _callee4, this);
      }));
      function renderThread(_x4, _x5) {
        return _renderThread.apply(this, arguments);
      }
      return renderThread;
    }()
  }, {
    key: "resolveTweet",
    value: function () {
      var _resolveTweet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(reference) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              return _context5.a(2, this.call('resolveTweet', reference));
          }
        }, _callee5, this);
      }));
      function resolveTweet(_x6) {
        return _resolveTweet.apply(this, arguments);
      }
      return resolveTweet;
    }()
  }, {
    key: "resolveReplyRoot",
    value: function () {
      var _resolveReplyRoot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(tx) {
        var _tx$returnMessage;
        var msg, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              msg = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || {};
              data = msg.data || {};
              if (!data.thread_id) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, data.thread_id);
            case 1:
              if (this.available('resolveReplyRoot')) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, '');
            case 2:
              return _context6.a(2, this.call('resolveReplyRoot', tx));
          }
        }, _callee6, this);
      }));
      function resolveReplyRoot(_x7) {
        return _resolveReplyRoot.apply(this, arguments);
      }
      return resolveReplyRoot;
    }()
  }, {
    key: "openThread",
    value: function () {
      var _openThread = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(rootTxSig) {
        var sourceTxSig,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              sourceTxSig = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : rootTxSig;
              return _context7.a(2, this.call('openThread', {
                root_tx_sig: rootTxSig,
                source_tx_sig: sourceTxSig
              }));
          }
        }, _callee7, this);
      }));
      function openThread(_x8) {
        return _openThread.apply(this, arguments);
      }
      return openThread;
    }()
  }]);
}();
module.exports = RedSquareBridge;